import React, { useContext, useEffect, useState } from 'react';
import Application from '../../../StateContext/Application.js';
import { apiurl } from '../../../../../path.js';
import { ProjectCreation64, BudgetHeadCreationBlue32, Cancel32, Add32, DeleteRed32, EditBlueBlue32, submit, Tax32, UpdateWhite32, EditIcon, DeleteIcon, Edit32WHITE, Delete32WHITE } from '../../../../../public/LoginImages/importimages';
import { useNavigate } from "react-router-dom";


const ReleasefromFinance = ({
  isEdit = false,
  projectData,
  onSuccess,
  onCancel
}) => {
  const navigate = useNavigate();
  const operation = useContext(Application);
  const { GetProjectInfo, GetBudgetHeadInfo, ReleaseFDUTF, ViewAllReleaseFDUTF, GetAgencyList } = operation;
  const [projectId, setProjectId] = useState([]);
  const [HeadId, setHeadID] = useState([]);
  const [relatedHeadID, setRelatedHeadID] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [AlltableData, setAllTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allProjects, setAllProjects] = useState([]);
  const [data, setData] = useState({
    FinancialYear: '',
    ProjectName: '',
    ProjectID: '',
    ReleaseAmountTillDate: '',
    Agency_Name: '',
    piu: '',
    Agency: "",
    BudgetHeadID: null,
    BudgetHeadName: "",
    ReleaseAmount: 0,
    ReleaseDate: null,
  });
  const [editIndex, setEditIndex] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [indexofediting, setIndexofEditing] = useState(null);
  const [agencyList, setAgencyList] = useState([]);
  const [IsEdit, setIsEdit] = useState(null);
  const [EditReleaseId, setEditReleaseId] = useState(null);

  const getMinDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const minDateTime = getMinDateTime();
  const HandleChangeData = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  }

  const formData = new FormData();
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     const formData = new FormData();

  //     // append file
  //     let ReleaseSanctionCopy = document.getElementById("ReleaseSanctionCopy").files;
  //     if (ReleaseSanctionCopy.length > 0) {
  //       formData.append("ReleaseSanctionCopy", ReleaseSanctionCopy[0]);
  //     }

  //     // append table data as JSON
  //     formData.append("tableData", JSON.stringify(tableData));

  //     console.log("Final payload:", formData);
  //     // Add this
  //     formData.append("type", "release");

  //     let result = await ReleaseFDUTF(formData);
  //     console.log(result);

  //     if (result.message) {
  //       alert(result.message);
  //       window.location.reload();
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const formData = new FormData();
      // File upload
      const ReleaseSanctionCopy = document.getElementById("ReleaseSanctionCopy").files;
      if (ReleaseSanctionCopy.length > 0) {
        formData.append("ReleaseSanctionCopy", ReleaseSanctionCopy[0]);
      }
      console.log("tableData:", tableData);
      // For create
      if (!isEdit) {
        formData.append("tableData", JSON.stringify(tableData));
        formData.append("type", "release");
        formData.append("typeData", "createReleaseData");
      }
      // For update
      else {
        formData.append("data", JSON.stringify(data));
        formData.append("typeData", "updateReleaseData");
      }
      console.log("Final FormData:", formData);
      const result = await ReleaseFDUTF(formData);
      console.log("API Response:", result);
      console.log("Update Data:", data);

      if (result.message) {
        alert(result.message);
        if (isEdit) {
          onSuccess();
        }
        else {
          window.location.reload();
        }

      }


    } catch (error) {

      console.error(
        "Release Submit Error:",
        error
      );

    } finally {
      setLoading(false);
    }
  };



  console.log("Head if ", HeadId)

  // Fetching 
  const FetchData = async () => {
    try {
      let res = await GetProjectInfo('null', "all");
      let res1 = await GetBudgetHeadInfo('null', "all");
      let res3 = await ViewAllReleaseFDUTF();
      console.log("Tbale data ::", res3);
      setAllProjects(res);// FOR THE YEAR WISE PROJECTS
      setProjectId(res);//uncommect on 22june fir budget head
      setHeadID(res1);
      setAllTableData(res3)
    }
    catch (err) {
      console.log(err);
    }
  }
  useEffect(() => {
    const fetchAgency = async () => {
      if (!data.Agency_Name) return;

      try {
        const res = await GetAgencyList();
        console.log("Agency List:", res);
        setAgencyList(res);
        const selectedAgency = res.find(
          item => item.Agency_Name === data.Agency_Name || data.AgencyName
        );

        if (selectedAgency) {
          setData(prev => ({
            ...prev,
            Agency: selectedAgency.Unique_Agency_Code
          }));
        }

      } catch (err) {
        console.log(err);
      }
    };

    fetchAgency();
  }, [data.Agency_Name]);
  const HeadIDFetchOperation = async (ID, IDtype) => {
    try {
      console.log(ID);
      if (IDtype == "ProjectId") {
        let res1 = await GetProjectInfo(ID, "id");
        console.log("Project ID ingo :: ", res1);
        let projectData = res1[0];

        console.log("project data i sleected ", projectData);

        // let apple = [...new Map(HeadId.filter(item => item.ProjectName === projectData.ProjectName).map(item => [item.HeadName, item])).values()];
        // console.log("Head related to project ", apple)
        // setRelatedHeadID(apple);



        setData((prev) => ({
          ...prev,
          FinancialYear: projectData.FinancialYear,
          ProjectName: projectData.ProjectName,
          ProjectID: projectData.ProjectId,
          ReleaseAmountTillDate: projectData.ProjectCost,
          ProjectCost: projectData.ProjectCost,
          piu: projectData.PIU,
          Agency_Name: projectData.Agency_Name,
          GRCopy: projectData.GRCopy,
          // BudgetHeadID: apple.length > 0 ? apple[0].HeadID : "",
          // BudgetHeadName: apple.length > 0 ? apple[0].HeadName : ""
        }))
      } else if (IDtype == "HeadID") {
        let res1 = await GetBudgetHeadInfo(ID, 'id');
        console.log("Head ID info ", res1);
        let HeadData = res1[0];
        setData((prev) => ({
          ...prev,
          BudgetHeadID: HeadData.HeadID,
          BudgetHeadName: HeadData.HeadName,
        }))
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  const uniqueHeads = [];

  const filteredData = HeadId.filter(item => {
    const isDuplicate = uniqueHeads.includes(item.HeadName);
    if (!isDuplicate) {
      uniqueHeads.push(item.HeadName);
      return true;
    }
    return false;
  });


  console.log("Filltered Data ", filteredData)

  useEffect(() => {
    FetchData()
  }, [])
  //commentec on 22june for budgethead
  // useEffect(() => {
  //     setFilteredProjects([]);
  //     setData(prev => ({
  //       ...prev,
  //       BudgetHeadID: "",
  //       ProjectID: "",
  //       ProjectName: ""
  //     }));
  //   }, [data.FinancialYear]);
  useEffect(() => {
    if (data.FinancialYear) {
      const filtered = allProjects.filter(
        p => p.FinancialYear === data.FinancialYear
      );

      setProjectId(filtered);
    } else {
      setProjectId(allProjects);
    }

    setData(prev => ({
      ...prev,
      ProjectID: "",
      ProjectName: "",
      BudgetHeadID: "",
      BudgetHeadName: ""
    }));

  }, [data.FinancialYear, allProjects]);
  const handleHeadChange = async (e) => {
    const headID = e.target.value;

    setData(prev => ({
      ...prev,
      BudgetHeadID: headID,
      ProjectID: "",
      ProjectName: "",
    }));

    if (!headID || !data.FinancialYear) {
      setFilteredProjects([]);
      return;
    }

    try {
      const res = await GetProjectInfo(
        {
          HeadID: headID,
          FinancialYear: data.FinancialYear
        },
        "ProjectsByHeadAndYear"
      );

      console.log("Projects by Head & Year:", res);
      setFilteredProjects(res);

      // Set head name
      const head = HeadId.find(h => h.HeadID == headID);
      if (head) {
        setData(prev => ({
          ...prev,
          BudgetHeadName: head.HeadName
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };
  const AddinTableOperation = (e) => {
    e.preventDefault();

    let obj = {
      projectId: data.ProjectID,
      projectName: data.ProjectName,
      year: data.FinancialYear,
      BudgetID: data.BudgetHeadID,
      BudgetHead: data.BudgetHeadName,
      ReleaseAmountTillDate: data.ProjectCost,
      amount: data.ReleaseAmount,
      piu: data.piu,
      Agency: data.Agency,
      Agency_Name: data.Agency_Name,
      currentDate: new Date().toISOString(),
      type: "release"
    }
    // data.ReleaseAmount = 0 //set amount zero after adding to table
    setData((prev) => ({
      ...prev,
      ReleaseAmount: isEdit ? data.ReleaseAmount : 0
    }));
    setTableData((prev) => [...prev, obj]);
  }
  const handelchangeTablre = (e) => {
    e.preventDefault();
    const updatedData = [...tableData];
    updatedData[indexofediting] = editIndex;
    setTableData(updatedData);
    console.log("Editted Index :: ", editIndex);
    setData((prev) => ({
      ...prev,
      ReleaseAmount: editIndex.amount,
    }));

    setEditIndex(null);
    setIndexofEditing(null);
  }
  const handleEdit = (e, index) => {
    e.preventDefault();
    const item = tableData[index];
    console.log("table i selected :: ", item)
    setEditIndex(item);
    setIndexofEditing(index);
  };

  const handleDelete = (e, index) => {
    e.preventDefault();
    const updated = tableData.filter((_, i) => i !== index);
    setTableData(updated);
  };

  useEffect(() => {
    if (!isEdit || !projectData || projectId.length === 0) return;
    // Find complete project information
    const selectedProject = projectId.find(
      p => String(p.ProjectId).trim() === String(projectData.ProjectID).trim()
    );
    console.log("Release Data :", projectData);
    console.log("Matched Project :", selectedProject);
    setData({
      ReleaseID: projectData.ReleaseID,
      FinancialYear: projectData.FinancialYear,
      ProjectID: projectData.ProjectID,
      ProjectName: projectData.ProjectName,
      ProjectCost: selectedProject?.ProjectCost || "",
      Agency_Name: selectedProject?.Agency_Name || "",
      GRCopy: selectedProject?.GRCopy || "",
      BudgetHeadID: projectData.BudgetHeadID,
      BudgetHeadName: projectData.BudgetHead,
      ReleaseAmountTillDate: projectData.ReleaseAmountTillDate,
      ReleaseAmount: projectData.ReleaseAmount,
      ReleaseDate:
        projectData.ReleaseDate &&
          projectData.ReleaseDate !== "0000-00-00 00:00:00"
          ? new Date(projectData.ReleaseDate)
            .toISOString()
            .slice(0, 16)
          : "",
      Remark: projectData.Remark || "",
      Agency: "",
      piu: selectedProject?.PIU || ""
    });
  }, [isEdit, projectData, projectId]);


  useEffect(() => {
    console.log("DATA STATE:", data);
    console.log("PROJECT OPTIONS:", projectId);
  }, [data, projectId]);


  return (
    <>
      <div style={{
        background: '#efecff',
        width: '100%',
        maxHeight: "91vh",
        transition: "margin-left 0.3s ease",
        overflowY: "auto",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        padding: 40,
        boxSizing: "border-box",
        fontFamily: 'Inter, sans-serif'
      }}>
        {loading && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)',
            zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center'
          }}>
            <div style={{
              border: '6px solid #f3f3f3', borderTop: '6px solid #007bff',
              borderRadius: '50%', width: '60px', height: '60px',
              animation: 'spin 1s linear infinite'
            }} />
            <style>{`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}</style>
          </div>
        )}

        <form style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          padding: "40px",
          maxWidth: "1100px",
          margin: "0 auto"
        }}>
          <div style={{ width: "100%", paddingLeft: "950px", paddingBottom: "10px" }}>
            <button style={{
              background: "#dc3545",
              color: "#fff",
              border: "none",
              padding: "8px 8px",
              borderRadius: "8px",
              cursor: "pointer",
              width: "60px",
              height: "30px",

            }} onClick={() => navigate(-1)}>
              ← Back
            </button>
          </div>
          {/* HEADER */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "15px 0",
            width: "auto",
            marginBottom: "30px",
            paddingRight: "70px"
          }}>
            {/* <img src={"/Release-From-Finance-64.png"} alt="Release" style={{
                marginRight: "10px",
                height: '25px',
                color: "#044c92"
              }} /> */}
            <h4 style={{
              margin: 0,
              color: "#044c92",
              fontWeight: 700,
              fontSize: "27px"
            }}>Fund Allocation</h4>
          </div>

          {/* FINANCIAL YEAR */}
          <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>Financial Year</label>
              </div>
              <div style={{ flex: 1 }}>
                <select name="FinancialYear" value={data.FinancialYear} onChange={HandleChangeData} style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "100%",
                  fontFamily: 'Inter, sans-serif'
                }}>
                  <option value="">Choose Financial Year</option>
                  <option value="2024-2025">2024 - 2025</option>
                  <option value="2025-2026">2025 - 2026</option>
                  <option value="2026-2027">2026 - 2027</option>
                </select>
              </div>
            </div>
          </div>

          {/* BUDGET HEAD */}
          {/* <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>Budget Head</label>
              </div>
              <div style={{ flex: 1 }}>
                <select name="BudgetHeadID" value={data.BudgetHeadID} onChange={handleHeadChange} style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "100%",
                  fontFamily: 'Inter, sans-serif'
                }}>
                  <option value="">Choose Budget Head</option>
                  {HeadId.map((val, index) => (
                    <option key={index} value={val.HeadID}>{val.CRC}/{val.HeadName}</option>
                  ))}
                </select>
              </div>
            </div>
          </div> */}

          {/* PROJECT NAME */}
          <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>Project Name</label>
              </div>
              <div style={{ flex: 1 }}>
                {/* <select name="ProjectID" value={data.ProjectID} onChange={(e) => {
                  const projectID = e.target.value;

                  console.log("Selected ProjectID:", projectID);
                  console.log("Filtered Projects:", filteredProjects);

                  const selectedProject = filteredProjects.find(
                    p => String(p.ProjectID) === String(projectID)
                  );

                  console.log("Selected Project Object:", selectedProject);

                  setData(prev => ({
                    ...prev,
                    ProjectID: selectedProject?.ProjectID || "",
                    ProjectName: selectedProject?.ProjectName || "",
                    ProjectCost: selectedProject?.ProjectCost || "",
                    piu: selectedProject?.PIU || "",
                    GRCopy: selectedProject?.GRCopy || ""
                  }));
                }}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "10px",
                    width: "100%",
                    fontFamily: 'Inter, sans-serif'
                  }}>
                  <option value="">Choose Project</option>
                  {filteredProjects.map((val, index) => (
                    <option key={index} value={val.ProjectID}>{val.ProjectName}</option>
                  ))}
                </select> */}
                <select
                  name="ProjectID"
                  value={data.ProjectID}
                  onChange={(e) => {

                    const projectID = e.target.value;

                    const selectedProject = projectId.find(
                      p =>
                        String(p.ProjectId).trim() === String(projectID).trim() ||
                        String(p.ProjectID).trim() === String(projectID).trim()
                    );

                    console.log("Selected Project:", selectedProject);
                    if (selectedProject) {
                      setData(prev => ({
                        ...prev,
                        ProjectID: selectedProject?.ProjectId || selectedProject?.ProjectID || "",
                        ProjectName: selectedProject?.ProjectName || "",
                        ProjectCost: selectedProject?.ProjectCost || "",
                        Agency_Name: selectedProject?.Agency_Name || "",
                        piu: selectedProject?.PIU || "",
                        GRCopy: selectedProject?.GRCopy || "",
                        BudgetHeadID: selectedProject?.HeadID || "",
                        BudgetHeadName: selectedProject?.HeadName || ""
                      }));
                    }
                  }}

                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    padding: "10px",
                    width: "100%",
                    fontFamily: "Inter, sans-serif"
                  }}
                >
                  <option value="">Choose Project</option>

                  {projectId.map((val, index) => (
                    <option
                      key={index}
                      value={val.ProjectId || val.ProjectID}
                    >
                      {val.ProjectName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* PROJECT COST */}
          <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>Project Cost</label>
              </div>
              <div style={{ flex: 1 }}>
                <input type="text" value={data.ProjectCost || '0'} readOnly style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "100%",
                  backgroundColor: "#cccccc",
                  opacity: "0.6"
                }} />
              </div>
            </div>
          </div>

          {/* PIU */}
          <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>Implementing Agency</label>
              </div>
              <div style={{ flex: 1 }}>
                <input type="text" value={data.Agency_Name || '--'} readOnly style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "100%",
                  backgroundColor: "#cccccc",
                  opacity: "0.6",
                  fontWeight: '700'
                }} />
              </div>
            </div>
          </div>

          {/* GR COPY */}
          <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>GR Copy</label>
              </div>
              <div style={{ flex: 1 }}>
                <input type="text" value={
                  data.GRCopy ? data.GRCopy : '--'
                } readOnly style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "100%",
                  backgroundColor: "#cccccc",
                  opacity: "0.6"
                }} />
              </div>
            </div>
          </div>

          {/* RELEASE DATE */}
          <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>Release Date</label>
              </div>
              <div style={{ flex: 1 }}>
                <input type="datetime-local" name='ReleaseDate' value={data.ReleaseDate || ''} onChange={HandleChangeData} style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "100%",
                  fontFamily: 'Inter, sans-serif'
                }} />
              </div>
            </div>
          </div>

          {/* RELEASE SANCTION COPY */}
          <div style={{ marginLeft: '60px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "30px",
                  textAlign: "left"
                }}>Release Sanction Copy Upload</label>
              </div>
              <div style={{ flex: 1 }}>
                <input type="file" id='ReleaseSanctionCopy' style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  width: "100%",
                  fontFamily: 'Inter, sans-serif'
                }} />
              </div>
            </div>
          </div>

          {/* RELEASE AMOUNT WITH ADD BUTTON */}
          <div style={{ marginLeft: '30px', width: '100%' }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px", marginRight: "200px" }}>
              <div style={{ width: "200px" }}>
                <label style={{
                  fontWeight: "700",
                  marginRight: "20px",
                  paddingLeft: "50px",
                  textAlign: "left"
                }}>Limit Allocation Amount</label>
              </div>
              <div style={{ flex: 1, display: "flex", gap: "10px", marginLeft: "15px" }}>
                <input type="number" placeholder='Enter Release Amount' name='ReleaseAmount' value={data.ReleaseAmount} onChange={HandleChangeData} style={{
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  padding: "10px",
                  flex: 1,
                  fontFamily: 'Inter, sans-serif'
                }} />
                <button onClick={AddinTableOperation} style={{
                  background: 'linear-gradient(to bottom, #044c92, #0071bc, #022f5a)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 20px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  fontSize: "1rem"
                }}><img src={Add32} style={{ marginRight: '20px', width: '1.5rem' }} />ADD</button>
              </div>
            </div>
          </div>

          {/* EDIT MODAL */}
          {editIndex && (
            <div style={{
              position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
              background: 'rgba(0, 0, 0, 0.5)', display: 'flex',
              justifyContent: 'center', alignItems: 'center', zIndex: 1000
            }}>
              <div style={{
                background: 'white', borderRadius: '16px', padding: '35px',
                maxWidth: '450px', width: '90%', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)'
              }}>
                <h4 style={{ marginBottom: '25px', fontSize: '20px', fontWeight: '700', color: '#044c92', textAlign: 'center' }}>
                  Edit Release
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <div>
                    <label style={{ fontWeight: '600', fontSize: '14px', color: '#333', marginBottom: '8px', display: 'block' }}>
                      Budget Head
                    </label>
                    <input type="text" value={editIndex.BudgetHead} disabled style={{
                      padding: '12px 14px', border: '1.5px solid #d0d8e8',
                      borderRadius: '8px', width: '100%', backgroundColor: '#f5f5f5'
                    }} />
                  </div>
                  <div>
                    <label style={{ fontWeight: '600', fontSize: '14px', color: '#333', marginBottom: '8px', display: 'block' }}>
                      Release Amount
                    </label>
                    <input type="number" value={editIndex.amount} name='amount' onChange={(e) => setEditIndex({ ...editIndex, amount: e.target.value })} style={{
                      padding: '12px 14px', border: '1.5px solid #d0d8e8',
                      borderRadius: '8px', width: '100%'
                    }} />
                  </div>
                  <div style={{ display: 'flex', gap: '12px', marginTop: '15px' }}>
                    <button onClick={handelchangeTablre} style={{
                      flex: 1, padding: '12px', background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                      color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer'
                    }}>{loading ? (isEdit ? "Updating..." : "Submitting...") : (isEdit ? "Update" : "Submit")}</button>
                    <button onClick={() => { setEditIndex(null); setIndexofEditing(null); }} style={{
                      flex: 1, padding: '12px', background: 'linear-gradient(135deg, #dc3545 0%, #e74c3c 100%)',
                      color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer'
                    }}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TABLE DATA */}
          {tableData && tableData.length > 0 && (
            <div style={{ marginRight: '60px', overflowX: "auto", display: "flex", justifyContent: "center", width: '100%', marginTop: '30px' }}>
              <table style={{
                backgroundColor: "white",
                width: "90%",
                maxWidth: "1000px",
                borderCollapse: "collapse",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                borderRadius: "8px",
                overflow: "hidden"
              }}>
                <thead>
                  <tr style={{
                    backgroundColor: "#2ea4e7",
                    color: "white",
                    fontSize: 13,
                    fontWeight: 600,
                    textAlign: "center",
                    whiteSpace: "nowrap"
                  }}>
                    <th style={{ padding: 10 }}>Year</th>
                    <th style={{ padding: 10 }}>Budget Head</th>
                    <th style={{ padding: 10 }}>Project Name</th>
                    <th style={{ padding: 10 }}>Amount</th>
                    <th style={{ padding: 10 }}>Date</th>
                    <th style={{ padding: 10 }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((val, index) => (
                    <tr key={index} style={{
                      backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white",
                      fontSize: 15,
                      fontWeight: 600,
                      textAlign: "center"
                    }}>
                      <td style={{ padding: 10 }}>{val.year}</td>
                      <td style={{ padding: 10, textAlign: 'left' }}>{val.BudgetHead}</td>
                      <td style={{ padding: 10, textAlign: 'left' }}>{val.projectName}</td>
                      <td style={{ padding: 10 }}>{Number(val.amount).toLocaleString('en-IN')}</td>
                      <td style={{ padding: 10 }}>{new Date(val.currentDate).toLocaleDateString('en-IN')}</td>
                      <td style={{ padding: "10px", display: "flex", justifyContent: "center", gap: "8px" }}>
                        <button onClick={(e) => handleEdit(e, index)} style={{
                          backgroundColor: "#2ea4e7", color: "white", border: "none",
                          borderRadius: "5px", padding: "5px 10px", fontWeight: "600", fontSize: "12px", cursor: "pointer"
                        }}>Edit</button>
                        <button onClick={(e) => handleDelete(e, index)} style={{
                          backgroundColor: "#dc3545", color: "white", border: "none",
                          borderRadius: "5px", padding: "5px 10px", fontWeight: "600", fontSize: "12px", cursor: "pointer"
                        }}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* SUBMIT & CANCEL BUTTONS */}
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "30px", width: '100%' }}>
            <button onClick={handleSubmit} style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
              width: "120px",
              height: "40px",
              backgroundColor: "#39b54a",
              border: "none",
              fontSize: "16px",
              color: "#ffffff",
              fontWeight: "700",
              cursor: "pointer"
            }}><img src={submit} style={{ marginRight: '10px', width: '1.2rem', paddingBottom: '3px', fontSize: '15px' }} /> Save</button>
            <button style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "20px",
              width: "120px",
              height: "40px",
              backgroundColor: "#ee5d50",
              opacity: '0.6',
              border: "none",
              fontSize: "16px",
              color: "#ffffff",
              fontWeight: "700",
              cursor: "pointer"
            }}><img src={Cancel32} style={{ marginRight: '10px', width: '1.2rem', }} /> Cancel</button>
          </div>
        </form >

        {/* ALL RELEASES TABLE */}
        {
          AlltableData && AlltableData.length > 0 && (
            <div style={{ marginTop: '40px', maxWidth: '1200px', margin: '40px auto' }}>

              <div style={{ overflowX: "auto", backgroundColor: 'white', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', padding: '20px' }}>

                <h5
                  style={{ fontWeight: '600', color: '#050505', marginBottom: '20px', paddingBottom: '15px', borderBottom: '2px solid #e8e5ff' }}

                >
                  <img
                    src={"/List-32.png"}
                    alt="Project Icon"
                    style={{ marginRight: "10px", width: 28, height: 28 }}
                  />
                  Fund List
                </h5>
                <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px' }}>
                  <thead>
                    <tr style={{
                      backgroundColor: "#2ea4e7",
                      color: "white",
                      fontSize: 13,
                      fontWeight: 600,
                      textAlign: "center",
                      whiteSpace: "nowrap"
                    }}>
                      <th style={{ padding: 12, textAlign: 'center' }}>Sr No</th>
                      <th style={{ padding: 12, textAlign: 'center' }}>Financial Year</th>
                      <th style={{ padding: 12, textAlign: 'center' }}>Project Name</th>
                      <th style={{ padding: 12, textAlign: 'center' }}>Project Cost</th>
                      <th style={{ padding: 12, textAlign: 'center' }}>Release Amount</th>
                      <th style={{ padding: 12, textAlign: 'center' }}>Release Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {AlltableData.map((val, index) => (
                      <tr key={index} style={{
                        backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white",
                        fontSize: 13,
                        fontWeight: 500,
                        textAlign: "center",
                        borderBottom: '1px solid #d1d5db'
                      }}>
                        <td style={{ padding: 12 }}>{index + 1}</td>
                        <td style={{ padding: 12 }}>{val.FinancialYear}</td>
                        <td style={{ padding: 12, textAlign: 'left', paddingLeft: '15px' }}>{val.ProjectName}</td>
                        <td style={{ padding: 12 }}>{Number(val.ReleaseAmountTillDate).toLocaleString('en-IN')}</td>
                        <td style={{ padding: 12, color: 'green', fontWeight: '600' }}>{Number(val.ReleaseAmount).toLocaleString('en-IN')}</td>
                        <td style={{ padding: 12 }}>{new Date(val.ReleaseDate).toLocaleDateString('en-IN')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )
        }
      </div >
    </>
  );
}

export default ReleasefromFinance